
import { defineComponent, onMounted, onBeforeUnmount, ref } from "vue";
import { getPointingDevice, PointingDeviceMouse } from "@/scripts/utils";
import { useRouter } from "vue-router";
import gsap from "gsap";
import HomeBackground from "@/components/HomeBackground.vue";
import AboutLink from "@/components/AboutLink.vue";

export default defineComponent({
  name: "Home",
  components: {
    HomeBackground,
    AboutLink
  },
  setup() {
    const router = useRouter();

    // set the link to portfolio
    const enterToPortfolio = () => {
      router.push("portfolio");
    };

    // references
    const isTitleBlink = ref<boolean>(false);
    const isTitleSplash = ref<boolean>(false);
    const isMouseMoved = ref<boolean>(false);
    const isShowAbout = ref<boolean>(false);
    const pointingDevice = ref<string>(getPointingDevice());

    // Mouse move handler
    let mouseTimer = 0;
    const mouseMoveListener = () => {
      clearTimeout(mouseTimer);
      isMouseMoved.value = true;
      isTitleSplash.value = true;
      mouseTimer = setTimeout(() => {
        isMouseMoved.value = false;
        isTitleSplash.value = false;
      }, 2000);
    };

    // Roll-up the title.
    const moveTitleEntry = () => {
      if (pointingDevice.value === PointingDeviceMouse) {
        isShowAbout.value = true;
        gsap.to(".site-title", {
          top: 0,
          transform: "translateY(0)",
          duration: "4",
          ease: "linear",
          onComplete: () => {
            window.setTimeout(() => {
              isTitleSplash.value = true;
              window.setTimeout(() => {
                isTitleSplash.value = false;
                window.addEventListener("mousemove", mouseMoveListener);
              }, 1200);
            }, 400);
          }
        });
      } else {
        gsap.to(".site-title", {
          top: "30%",
          duration: "1.2",
          ease: "linear",
          onComplete: () => {
            window.setTimeout(() => {
              isTitleSplash.value = true;
              window.setTimeout(() => {
                isTitleSplash.value = false;
                gsap.set(".tap-notice", { opacity: 1 });
                window.setTimeout(() => {
                  isTitleBlink.value = true;
                  isShowAbout.value = true;
                }, 1200);
              }, 1800);
            }, 400);
          }
        });
      }
    };

    // Block over scroll on Safari
    const scrollWheelListener = (ev: WheelEvent) => {
      ev.preventDefault();
    };

    // Setup title block rollup
    onMounted(() => {
      window.setTimeout(moveTitleEntry, 3000);
      window.addEventListener("wheel", scrollWheelListener, {
        passive: false
      });
      if (getPointingDevice() !== PointingDeviceMouse) {
        gsap.set(".portfolio-link", { display: "none" });
      }
    });
    onBeforeUnmount(() => {
      window.removeEventListener("wheel", scrollWheelListener);
      window.removeEventListener("mousemove", mouseMoveListener);
    });

    // Return reactive items
    return {
      isMouseMoved,
      isShowAbout,
      isTitleBlink,
      isTitleSplash,
      pointingDevice,
      enterToPortfolio
    };
  }
});
